import { Jwt } from './jwt';

export class AuthTokens {
  public jwt: Jwt;
  public accessToken?: string;

  private constructor(jwt: Jwt, accessToken?: string) {
    this.jwt = jwt;
    this.accessToken = accessToken;
  }

  public static new(jwt: Jwt, accessToken?: string): AuthTokens {
    return new AuthTokens(jwt, accessToken);
  }
}
